import { Link } from 'react-router-dom';
import { siteContent } from '@/mocks/pt/siteContent';

export default function CtaArticleSection() {
  const { ctaArticle } = siteContent;

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20office%20with%20wide%20monitor%20showing%20colorful%20spreadsheet%20data%20plants%20and%20notebook%20on%20light%20wood%20desk%20bright%20natural%20lighting%20editorial%20workspace%20aesthetic%20clean%20productive%20environment&width=1600&height=900&seq=cta-article-v2-2026&orientation=landscape"
          alt="CSSBuy Spreadsheet Guide 2026"
          title="Guia CSSBuy Spreadsheet"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-16 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-wide mb-5">
            {ctaArticle.title}
          </h2>
          <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto mb-8 leading-relaxed">
            {ctaArticle.subtitle}
          </p>
          <Link
            to="/artigo/guia-cssbuy-spreadsheet"
            className="group inline-flex items-center gap-3 px-7 py-3.5 bg-foreground-900 hover:bg-foreground-800 text-white font-semibold text-sm rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
              <i className="ri-file-text-line text-sm text-white w-4 h-4 flex items-center justify-center"></i>
            </span>
            <span>{ctaArticle.buttonText}</span>
            <i className="ri-arrow-right-up-line text-lg w-5 h-5 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}